import getters from '@/store/lib/getters'

export default {
  ...getters,

  updatable: (state) => {
    if (state.email === '') return false
    return true
  }
}
